import React from "react";
import styled, { css, useTheme } from "styled-components";
import { Label } from "components/bootstrap";
const ColorLabelWrap = styled.span(({ $size, theme }) => {
  const { body, small, tiny } = theme.fonts.size;
  const fontSize = $size === "small" ? small : body;
  return css`
    vertical-align: middle;
    font-size: ${$size === "xsmall" ? tiny : fontSize};
  `;
});
const ColorLabel = ({ color, size = "normal", text = /* @__PURE__ */ React.createElement("span", null, "\u2003") }) => {
  const theme = useTheme();
  const borderColor = theme.utils.colorLevel(color, 5);
  const textColor = theme.utils.contrastingColor(color);
  return /* @__PURE__ */ React.createElement(ColorLabelWrap, { $size: size, className: "color-label-wrapper" }, /* @__PURE__ */ React.createElement(
    Label,
    {
      style: {
        backgroundColor: color,
        border: `1px solid ${borderColor}`,
        color: textColor,
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "128px",
        marginRight: "4px",
        marginBottom: "4px"
      }
    },
    text
  ));
};
export default ColorLabel;
